import { render, staticRenderFns } from "./Lawyer.vue?vue&type=template&id=56186890&scoped=true&"
import script from "./Lawyer.vue?vue&type=script&lang=js&"
export * from "./Lawyer.vue?vue&type=script&lang=js&"
import style0 from "./Lawyer.vue?vue&type=style&index=0&id=56186890&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56186890",
  null
  
)

export default component.exports